import React from 'react';
import { graphql } from 'gatsby';
import SvgSafeGatsbyImage from '@atoms/SvgSafeGatsbyImage';
import Container from '@atoms/Container';
import RichTextEditorStyles from '@utils/RichTextEditorStyles';
import apCaseOnlyTitleTags from '@utils/apCaseOnlyTitleTags';
import { colors } from '../primitives/colors';
import { StyledButtonAsLink } from '../primitives/styled-button';

const CommunityBanner = ({ data }) => {
    const { background, content } = data;
    const { alignment, headline, copy, icon, button_link, disable_content } = content;
    const { image, fill_screen_height } = background;

    return (
        <div css={styles.communityBannerWrap(!!fill_screen_height)}>
            <Container>
                {!disable_content && (
                    <div css={styles.content(alignment || 'left')}>
                        {!!icon?.url && <SvgSafeGatsbyImage css={styles.icon} image={icon} alt={icon.title} />}
                        <h3
                            css={styles.headline}
                            dangerouslySetInnerHTML={{
                                __html: apCaseOnlyTitleTags(headline)
                            }}
                        />
                        <div
                            css={[RichTextEditorStyles, styles.copy]}
                            dangerouslySetInnerHTML={{ __html: copy }}
                        />
                        {!!button_link?.title && (
                            <div css={styles.linkWrap}>
                                <StyledButtonAsLink to={button_link.href}>{button_link.title}</StyledButtonAsLink>
                            </div>
                        )}
                    </div>
                )}
                {!!image?.url && (
                    <div css={styles.backgroundImageWrap}>
                        <SvgSafeGatsbyImage css={styles.backgroundImage} image={image} alt={image.description} />
                    </div>
                )}
            </Container>
        </div>
    );
};

const styles = {
    communityBannerWrap: (fullFill) => ({
        position: "relative",
        paddingTop: "3.5rem",
        paddingBottom: "5rem",
        "@media (min-width: 768px)": {
            paddingTop: "5rem",
            paddingBottom: "5rem",
        },
        "@media (min-width: 1024px)": {
            paddingTop: "10rem",
            paddingBottom: "13rem",
            minHeight: fullFill && "100vh",
        }
    }),
    content: (alignment) => ({
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        position: "relative",
        zIndex: 10,
        padding: "2rem",
        color: colors.shadesBlack,
        marginLeft: (alignment === 'right' || alignment === 'center') && "auto",
        marginRight: (alignment === 'left' || alignment === 'center') && "auto",
        backgroundColor: "rgba(255, 255, 255, 0.7)",
        borderRadius: "5px",
        "@media (min-width: 1024px)": {
            maxWidth: (alignment === 'right' || alignment === 'left') && "28rem",
        }
    }),
    headline: {
        lineHeight: 1.19,
        fontSize: "36px",
        marginBottom: "1.5rem",
    },
    copy: {
        fontSize: "1.25rem",
        lineHeight: 1.375,
    },
    linkWrap: {
        marginTop: "1.25rem",
    },
    icon: {
        marginBottom: "2rem",
        maxHeight: "77px",
    },
    backgroundImageWrap: {
        position: "absolute",
        top: "0",
        right: "0",
        bottom: "0",
        left: "0",
    },
    backgroundImage: {
        // the commented styles below were from tailwind classes but don't appear to be needed
        // "position": "absolute",
        // "top": "0",
        // "right": "0",
        // "bottom": "0",
        // "left": "0",
        objectFit: "cover",
        zIndex: 0,
        width: "100%",
        height: "100%",
    }
};

export const query = graphql`
  fragment CommunityBannerData on CmsPageBuilderBlocks {
    community_banner {
      background {
        fill_screen_height
        image {
          filename
          title
          url
          description
            contentStackAsset(width: 1440)
        }
      }
      content {
        disable_content
        alignment
        headline
        copy
        button_link {
          title
          href
        }
        icon {
          filename
          title
          url
            contentStackAsset(width: 100)
        }
      }
    }
  }
`;

export default CommunityBanner;